import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@gc-npm/reducers.modals-reducer";
import { types as mainActions } from "@gc-npm/reducers.main-reducer";
import { types as trackingTypes } from "@gc-npm/reducers.tracking-reducer";

import * as trackingSagas from "./tracking-saga";

import {
  initAnchorModalListener,
  addModal,
} from "@gc-npm/sagas.modals-saga";
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from "@gc-npm/sagas.main-saga";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    //cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    // tracking
    takeLatest(
      trackingTypes.ORDER_DETAILS_TRACKING_BEGINS,
      trackingSagas.getOrderDetails
    ),
    takeLatest(
      trackingTypes.GET_LIST_TRACKING_BEGINS,
      trackingSagas.getListTracking
    ),
    takeLatest(
      trackingTypes.GET_DETAIL_TRACKING_BEGINS,
      trackingSagas.getDetailTracking
    ),
    takeLatest(
      trackingTypes.GET_SLOTS_TRACKING_BEGINS,
      trackingSagas.getSlotsTracking
    ),
    takeLatest(
      trackingTypes.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS,
      trackingSagas.postModifyAppointment
    ),
    // notifications

    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga
    ),
  ]);
}

export default rootSaga;
